<template>
    <b-container id="user-sign-in">
        <b-row>
            <b-col class="sign-in-logo">
                <b-img :src="env.COMPANY_APP_URL + '/storage/images/logo.png'"></b-img>
            </b-col>
        </b-row>
        <b-row>
            <b-col />
            <b-col>
                <b-form @submit.prevent="submit">
                    <b-form-group
                        id="input-group-email"

                    >
                        <b-form-input
                            id="input-email"
                            v-model="form.email"
                            type="email"
                            required
                            placeholder="Enter e-mail"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-password"

                    >
                        <b-form-input
                            id="input-password"
                            v-model="form.password"
                            type="password"
                            required
                            placeholder="Enter password"
                        ></b-form-input>
                    </b-form-group>
                    <div class="forgot-password text-right"><b-link @click="openModal('modal-sign-in-forgot-password')">Forgot Password</b-link></div>
                    <b-button type="submit" variant="success" class="login-button">Login</b-button>
                </b-form>
            </b-col>
            <b-col />
        </b-row>

        <b-modal id="modal-sign-in-forgot-password" hide-footer>
            <template v-slot:modal-title>
                Reset Password
            </template>

            <b-form @submit.prevent="submitReset">
                <b-form-group
                    id="input-group-email-reset"

                >
                    <b-form-input
                        id="input-email-reset"
                        v-model="resetEmail"
                        type="email"
                        required
                        placeholder="Enter e-mail"
                    ></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="success" class="reset-button">Reset</b-button>
            </b-form>
        </b-modal>
    </b-container>
</template>

<script>
    import { AbilityBuilder } from '@casl/ability'
    import { mapGetters, mapActions, mapMutations } from 'vuex'

    export default {
        name: 'SignIn',

        data () {
            return {
                form: {
                    email: '',
                    password: '',
                },

                resetEmail: ''
            }
        },

        computed: {
            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                abilities: 'auth/abilities'
            })
        },

        methods: {
            ...mapActions({
                signIn: 'auth/signIn'
            }),

            async submit () {
                let result = await this.signIn(this.form)

                if (result == 'login error') {
                    this.showAlertBox('error', 'Login Error', 'Please double check credentials!')
                } else {
                    axios.get('/api/user/permissions').then((response) => {
                        if (window.location.pathname != '/') {
                            this.$router.push({ name: 'Home'})
                        }

                        this.setAbility(response.data)
                        this.updateAbility(this.abilities)

                        // let routeCheck = this.$router.resolve({path: window.location.pathname})

                        // if ((window.location.pathname != '/' && routeCheck) && window.location.pathname != this.$router.currentRoute.path) {
                        //     this.$router.push({ name: routeCheck.route.name })
                        //     console.log('pushed')
                        // }
                    }).catch((err) => {
                        // console.log(err)
                    })
                }
            },

            submitReset() {
                const crypto = require('crypto')
                crypto.randomBytes(20, (err, buffer) => {
                    var token = buffer.toString('hex')

                    let url = 'password/email'
                    axios.post(url, {
                        token: token,
                        email: this.resetEmail
                    })
                    .then((res) => {
                        this.closeModal('modal-sign-in-forgot-password')
                        this.showAlertBox('success', 'Reset Password', 'Password reset instructions emailed.')
                    }, (err) => {
                        this.has_error = true
                        let errorResp = err.response.data
                        if (errorResp.errors.email) {
                            let msg = errorResp.errors.email[0]
                            this.showAlertBox('error', 'Error', msg)
                        } else {
                            this.showAlertBox('error', 'Error', 'Error resetting password, please try again.')
                        }
                    })
                })
            },

            ...mapMutations({
                setAbility: 'auth/SET_ABILITIES'

            }),

            updateAbility(abilities) {
                const { can, rules } = new AbilityBuilder();

                let obj = abilities
                obj.forEach(element => {
                    can(element.name, '')
                })

                this.$ability.update(rules);
            },

            openModal(modalName) {
                this.$bvModal.show(modalName)
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },
        },

        mounted() {
            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                if (modalId == 'modal-sign-in-forgot-password') {
                    this.resetEmail = ''
                }
            })
        }
    }
</script>
<style lang="scss">
    #user-sign-in {
        .sign-in-logo {
            text-align: center;
            margin-left: auto;
            margin-right: auto;
            margin: 0px;
            padding-bottom: 20px;

            img {
                filter: invert(100%);
            }
        }

        #input-group-password {
            margin-bottom: 0px;
        }

        .forgot-password {
            padding-bottom: 10px;
            font-size: 10pt;
        }

        .login-button {
            width: 100%;
            text-align: center;
        }
    }
</style>
